import { t } from '../common/LocalizationProvider'

export default {
  'speedLimit': {
    name: t('attributeSpeedLimit'),
    type: 'string',
  },
};
